/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useEffect, useState } from "react";

import { usePlayerController } from "../BasePlayer";

export const usePlayerCastState = () => {
  const { player } = usePlayerController();

  const [isCastConnected, setIsCastConnected] = useState<boolean>(
    player.isCastConnected(),
  );
  const [castDeviceName, setCastDeviceName] = useState<string>(
    player.getCastDeviceName(),
  );

  useEffect(() => {
    setIsCastConnected(player.isCastConnected());

    const unsubscribeCastConnected = player.onEvent(["castconnected"], () => {
      setIsCastConnected(true);
      setCastDeviceName(player.getCastDeviceName());
    });
    const unsubscribeCastDisconnected = player.onEvent(
      ["castdisconnected"],
      () => {
        setIsCastConnected(false);
        setCastDeviceName("");
      },
    );

    return () => {
      unsubscribeCastConnected();
      unsubscribeCastDisconnected();
    };
  }, [player]);

  return { isCastConnected, castDeviceName };
};
